export default {
  state: {
    popupOrder: {
      visible: false,
      orderId: null
    },
    setNextPage: [],
    wizardMenu: [
      {
        step: 1,
        title: 'Plan',
        isActive: true,
        view: false,
        lastItem: true
      },
      {
        step: 2,
        title: 'Customise',
        isActive: false,
        view: false,
        lastItem: false
      },
      {
        step: 3,
        title: 'Protein',
        isActive: false,
        view: false,
        lastItem: false
      },
      {
        step: 4,
        title: 'Days',
        isActive: false,
        view: false,
        lastItem: false
      },
      {
        step: 5,
        title: 'Meals',
        isActive: false,
        view: false,
        lastItem: false
      },
      {
        step: 6,
        title: 'Review',
        isActive: false,
        view: false,
        lastItem: false
      },
      // {
      //     step: 6,
      //     title: 'Review',
      //     isActive: false,
      //     view: false,
      //      lastItem: false
      // }
    ],
    alertApp: {
      visible: false,
      title: '',
      text: '',
      type: ''
    },
  },
  mutations: {     
    setPopupOrder (state, payload ) {
      state.popupOrder = payload || {};
    },
    setAlertData(state, payload) {
      state.alertApp = payload || {};
    },
    setNextPage(state, payload) {
      state.setNextPage = payload || [];
    },
    setWizardMenu(state, payload) {
      state.wizardMenu = payload || [];
    }
  },
  getters: {  
    popupOrder ( state ) {
      return state.popupOrder;
    },
    wizardMenu(state) {
      return state.wizardMenu;
    },
    alertApp(state) {
      return state.alertApp;
    },
    setNextPage(state) {
      return state.setNextPage;
    },
  }
}
